"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var google_tag_manager_1 = require("./google-tag-manager");
exports.default = google_tag_manager_1.default;
